import {css,createGlobalStyle} from "styled-components";

export const clearFix = css`
  &::after {
      content: "";
      display: table;
      clear: both;
  }
`

export default createGlobalStyle`
  .fix,
  .clearfix {
    ${clearFix}
  }

  .fl {
      float: left;
  }

  .fr {
      float: right;
  }

  .hide {
      display: none;
  }

  .hidden {
      display: none!important;
  }

  .block {
      display: block!important;
  }

  .inline-block {
      display: inline-block!important;
  }

  .scripts {
      display: none;
  }

  .block-img {
      text-align: center;
  }

  .block-img img {
      width: 100%;
      vertical-align: top;
  }

  .nano .content:focus {
      outline: none;
  }
`;
